import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
// import { navItems } from './sidebar-data';
import { NavService } from '../../../services/nav.service';
import { MatSidenav } from '@angular/material/sidenav';
import { BaseServicesService } from 'src/app/services/base-services/base-services.service';
import { NavItem } from './nav-item/nav-item';
import { LoggingService } from 'src/app/services/consoleLogs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit {
  navItems: NavItem[] = []; // Initialize as empty array
  isLoading: boolean = true;

  constructor(
    public navService: NavService,
    
    private baseService: BaseServicesService,
    private loggingService: LoggingService,
    private router: Router
  ) { }

  @Input() isCollapsed: boolean = false;

  ngOnInit(): void {
    this.sidenNavFeatureApi();
  }

  @Input() sidenav!: MatSidenav;

  toggleSidenav(): void {
    this.sidenav.toggle();
  }

  findParentNavCapByChildName(childName: string): string | null {
    for (const parent of this.navItems) {
      if (
        parent.children &&
        parent.children.some((c) => c.displayName === childName)
      ) {
        return parent.navCap ?? null; // if undefined, return null
      }
    }
    return null;
  }

  sidenNavFeatureApi(): void {
    this.isLoading = true;

    this.baseService.getFeatureOptions().subscribe({
      next: (res) => {
        this.isLoading = false;
        this.loggingService.log('API Response:', res);

        if (res.data && res.data.features) {
          this.navItems = this.transformApiResponse(res.data.features);
          // this.breadcrumbService.setNavItems(this.navItems);

          this.loggingService.log('Transformed Nav Items:', this.navItems);

          const parent = this.findParentNavCapByChildName('Analytics');
          this.loggingService.log('Parent navCap of Analytics:', parent);
        } else {
          this.loggingService.warn('Invalid API response structure');
          this.navItems = [];
        }
      },
      error: (err) => {
        this.isLoading = false;
        this.loggingService.error('API Error:', err);
        this.navItems = [];
      },
    });
  }

  private transformApiResponse(features: any[]): NavItem[] {
    return features
      .filter((feature) => {
        const hasNavCap = !!feature.navCap;
        const hasChildren = feature.children && feature.children.length > 0;
        return hasNavCap && hasChildren;
      })
      .map((feature) => ({
        id: feature.id,
        navCap: feature.navCap,
        expanded: feature.expanded || false,
        children: (feature.children || [])
          .map((child: any) => ({
            displayName: child.displayName,
            iconName: child.iconName,
            route: child.route,
            relatedRoutes: child.relatedRoutes || [],
            disabled: child.disabled || false,
            external: child.external || false,
            permissionType: child.permissionType,

            // ✅ MAP TABS HERE
            tabs: child.tabs
              ? child.tabs.map((tab: any) => ({
                tabName: tab.tabName,
                route: tab.route,
                iconName: tab.iconName,
                permissionType: tab.permissionType,
              }))
              : []
          }))
          .filter((child: any) => child.displayName && child.route),
      }))
      .filter((navItem) => navItem.children.length > 0);
  }

  logout(): void {
    this.router.navigate(['/']);
    localStorage.removeItem('authToken');
  }

}
